import { SwitcherItemViewModel } from "./switcher-item.view-model";
import { ESwitcherAssetType } from "../../../domain/broadcasts/switcher-item.type.enum";
import { MediaItem } from "../../../domain/media";
import { LiveFeedInfo } from "../../../domain/live-feed";
import { GraphicsInfo } from "../../../domain/graphics-info";
import { Layout } from "../../../domain/layouts/layout";
import { Block } from "../../../domain/blocks/block";
import { UI } from "../../../services/ui.service";
import { Switcher } from "../../../domain/broadcasts/switcher";
import { IBroadcastsRepository } from "../../../domain/broadcasts/i-broadcasts-repository";
import { BroadcastPresetViewModel } from "./broadcast-preset.view-model";
import { ICommonUtilInterface } from "../../../domain/common/common-util.interface";
import { ChangeDetectorRef } from "@angular/core";
import { IBlockRepository } from "app/js/src/domain/blocks/i-block.repository";
import { SwitcherItem } from "app/js/src/domain/broadcasts/switcher-item";

const GRID_COLS = 6;
const GRID_ROWS = 2;

export class SwitcherViewModel extends Switcher {
  public get itemsVMs(): SwitcherItemViewModel[] {
    return this.items as SwitcherItemViewModel[];
  }
  public nameCanBeEdited = false;
  public get nameVM(): string {
    if (this.nameCanBeEdited) {
      return this.name;
    } else {
      let slicedName = this.name.substring(0, 13);
      if (slicedName.length > 12) {
        slicedName += "...";
      }
      return slicedName;
    }
  }
  public set nameVM(val) {
    this.name = val;
  }
  constructor(
    switcher: Switcher,
    private changeDetectorRef: ChangeDetectorRef,
    private _ui: UI,
    private _broadcastsRepository: IBroadcastsRepository,
    private _blocksRepository: IBlockRepository,
  ) {
    super(
      switcher.name,
      switcher.items.map((i) => {
        const item = new SwitcherItemViewModel(
          i,
          changeDetectorRef,
          _ui,
          _broadcastsRepository,
        );
        return item;
      }),
    );
    /*for (let i = 0; i < 12; i++) {
        const assetType = Math.floor(Math.random() * 6)as ESwitcherAssetType;
        this.items.push(new SwitcherItemViewModel( new SwitcherItem(assetType, i, ESwitcherAssetType[assetType], 'https://s3.eu-central-1.wasabisys.com/icpublicuploads/be35bafc-b548-ea11-9132-ac1f6b712c7b/thumb/thumb_0af850a3-3212-ed11-90f1-a0423f495001.png', -1, 0, 0, false, false, false), _ui));
    }*/
  }

  onNameDoubleClicked(event: MouseEvent) {
    this.nameCanBeEdited = true;
    setTimeout(() => {
      const nameDiv = event.target as HTMLDivElement;
      const range = document.createRange();
      range.selectNodeContents(nameDiv);
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
      setTimeout(() => nameDiv.focus(), 50);
    }, 50);

    event.preventDefault();
    event.stopPropagation();
  }
  public handleContentEditablePaste(event: ClipboardEvent, property: string) {
    event.preventDefault();
    const text = event.clipboardData.getData("text/plain");
    if (text) {
      this[property] = this[property] + text.replace(/[\r\n]+/g, " ");
    }
  }
  public updateItems(newItems: SwitcherItem[]) {
    for (var item of newItems) {
      var newItem = new SwitcherItemViewModel(
        item,
        this.changeDetectorRef,
        this._ui,
        this._broadcastsRepository,
      );
      (this.items[item.index] as SwitcherItemViewModel).mergeWith(newItem);
    }
  }

  getRowCol(index: number): { row: number; col: number } {
    return {
      row: Math.floor(index / GRID_COLS),
      col: index % GRID_COLS,
    };
  }

  isCovered(index: number): boolean {
    const { row, col } = this.getRowCol(index);
    for (let i = 0; i < this.items.length; i++) {
      const master = this.items[i] as SwitcherItemViewModel;
      if (
        master.type === ESwitcherAssetType.Empty ||
        (master.colSpan === 1 && master.rowSpan === 1)
      ) {
        continue;
      }
      if (i === index) {
        continue;
      }
      const mc = this.getRowCol(i);
      if (
        col >= mc.col &&
        col < mc.col + master.colSpan &&
        row >= mc.row &&
        row < mc.row + master.rowSpan
      ) {
        return true;
      }
    }
    return false;
  }

  getMasterCovering(index: number): SwitcherItemViewModel | null {
    const { row, col } = this.getRowCol(index);
    for (let i = 0; i < this.items.length; i++) {
      if (i === index) {
        continue;
      }
      const master = this.items[i] as SwitcherItemViewModel;
      if (master.type === ESwitcherAssetType.Empty) {
        continue;
      }
      const mc = this.getRowCol(i);
      if (
        col >= mc.col &&
        col < mc.col + master.colSpan &&
        row >= mc.row &&
        row < mc.row + master.rowSpan
      ) {
        return master;
      }
    }
    return null;
  }

  getGridColumn(item: SwitcherItemViewModel): string {
    const { col } = this.getRowCol(item.index);
    return `${col + 1} / span ${item.colSpan}`;
  }

  getGridRow(item: SwitcherItemViewModel): string {
    const { row } = this.getRowCol(item.index);
    return `${row + 1} / span ${item.rowSpan}`;
  }

  canExpandRight(item: SwitcherItemViewModel): boolean {
    const { row, col } = this.getRowCol(item.index);
    const nextCol = col + item.colSpan;
    if (nextCol >= GRID_COLS) {
      return false;
    }
    for (let r = row; r < row + item.rowSpan; r++) {
      const tileIndex = r * GRID_COLS + nextCol;
      const tile = this.items[tileIndex] as SwitcherItemViewModel;
      if (!tile || tile.type !== ESwitcherAssetType.Empty) {
        return false;
      }
      if (this.isCovered(tileIndex)) {
        return false;
      }
    }
    return true;
  }

  canExpandDown(item: SwitcherItemViewModel): boolean {
    const { row, col } = this.getRowCol(item.index);
    const nextRow = row + item.rowSpan;
    if (nextRow >= GRID_ROWS) {
      return false;
    }
    for (let c = col; c < col + item.colSpan; c++) {
      const tileIndex = nextRow * GRID_COLS + c;
      const tile = this.items[tileIndex] as SwitcherItemViewModel;
      if (!tile || tile.type !== ESwitcherAssetType.Empty) {
        return false;
      }
      if (this.isCovered(tileIndex)) {
        return false;
      }
    }
    return true;
  }

  canShrinkRight(item: SwitcherItemViewModel): boolean {
    return item.colSpan > 1;
  }

  canShrinkDown(item: SwitcherItemViewModel): boolean {
    return item.rowSpan > 1;
  }

  expandRight(item: SwitcherItemViewModel): void {
    if (!this.canExpandRight(item)) {
      this._ui.notify(this._ui.EVENTS.ShowAlert, {
        title: 'Expand Failed',
        message: 'Cannot expand right: tile is occupied or out of bounds.',
      });
      return;
    }
    item.colSpan += 1;
  }

  expandDown(item: SwitcherItemViewModel): void {
    if (!this.canExpandDown(item)) {
      this._ui.notify(this._ui.EVENTS.ShowAlert, {
        title: 'Expand Failed',
        message: 'Cannot expand down: tile is occupied or out of bounds.',
      });
      return;
    }
    item.rowSpan += 1;
  }

  shrinkRight(item: SwitcherItemViewModel): void {
    if (item.colSpan > 1) {
      item.colSpan -= 1;
    }
  }

  shrinkDown(item: SwitcherItemViewModel): void {
    if (item.rowSpan > 1) {
      item.rowSpan -= 1;
    }
  }
}
